import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentForRouteMangerPrintOption } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalRow = this.props.total;

        return (
            <div>
                <h3 className="pr-2"><center><u>Factory Weight Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table
                    id="example"
                    className="display dataTable">
                    <thead>
                        <tr>
                            <th style={{ textAlign: "left" }} rowSpan="2">Route</th>
                            <th style={{ textAlign: "right" }} rowSpan="2">Bag Count</th>
                            <th style={{ textAlign: "right" }} rowSpan="2">Actual Weight</th>
                            <th style={{ textAlign: "center" }} colSpan="6">Deductions</th>
                            <th style={{ textAlign: "right" }} rowSpan="2">Actual Net</th>
                            <th style={{ textAlign: "right" }} rowSpan="2">Net Weight</th>
                            <th style={{ textAlign: "right" }} rowSpan="2">Gain/Loss</th>
                        </tr>
                        <tr>
                            <th style={{ textAlign: "right" }}>Water</th>
                            <th style={{ textAlign: "right" }}>Bag</th>
                            <th style={{ textAlign: "right" }}>Box</th>
                            <th style={{ textAlign: "right" }}>Boiled Leaf</th>
                            <th style={{ textAlign: "right" }}>Coarse Leaf</th>
                            <th style={{ textAlign: "right" }}>Other</th>
                        </tr>
                    </thead>
                    <tbody>
                        <TableContentForRouteMangerPrintOption
                            data={resultData}
                            contentRowNames={contentRowNames}
                            hasEdit={false}
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <th style={{ textAlign: "left" }}>Total</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.bagCount !== undefined) ? Number(totalRow.bagCount).toFixed(0) : "0"}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.actualAmount !== undefined) ? Number(totalRow.actualAmount).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.water !== undefined) ? Number(totalRow.water).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.bag !== undefined) ? Number(totalRow.bag).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.box !== undefined) ? Number(totalRow.box).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.boiledLeaf !== undefined) ? Number(totalRow.boiledLeaf).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.coarseLeaf !== undefined) ? Number(totalRow.coarseLeaf).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.other !== undefined) ? Number(totalRow.other).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.actualNet !== undefined) ? Number(totalRow.actualNet).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.netWeight !== undefined) ? Number(totalRow.netWeight).toFixed(2) : (0).toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{(totalRow && totalRow.gainLoss !== undefined) ? Number(totalRow.gainLoss).toFixed(2) : (0).toFixed(2)}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}